"use strict";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

Shopify.theme.jsAjaxCart = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsAjaxCart = $.extend(this, Shopify.theme.getSectionData($section));

    if (isScreenSizeLarge() || this.cart_action == 'drawer') {
      this.initializeAjaxCart();
    } else {
      this.initializeAjaxCartOnMobile();
    }

    if (this.cart_action == 'drawer') {
      this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');

      $(document).on('click', '[data-ajax-cart-trigger]', function (e) {
        console.log("event is: ", e)

        /****
         * HACK: [data-ajax-cart-trigger] is the top-level cart element.
         * Because this listener attaches a delegated click listener that prevents the default action for all child
         * cart elements, custom checkboxes and other form fields don't respond to changes.
         * I've added checks for the added gift message and shipping notice event handlers in the cases below
         * to allow them to work.
         */
        if(e.target && e.target.id === "gift_toggle") {
          if(e.target.checked){ //had to flip to ! to temp work
            e.target.closest(".ajax-cart__details-row").querySelector(".gift_message_toggle").classList.remove("gift_msg_toggled_off")
            e.target.value="Yes";
          } else {
            e.target.closest(".ajax-cart__details-row").querySelector(".gift_message_toggle").classList.add("gift_msg_toggled_off")
            e.target.value="";
          }
          return;  //Do not continue and reload the entire cart
        } else if (e.target && e.target.id === "ship_agreement") {
          if(e.target.checked) {
            console.log("checked!")
          } else {
            console.log("not checked!")
          }
          return;
        }

        //Resume non-custom code

        e.preventDefault();
        Shopify.theme.jsAjaxCart.showDrawer();
        return false;
      });
    } else if (this.cart_action == 'mini_cart') {
      this.showMiniCartOnHover();
    }

    $(document).on('click', '.ajax-submit', function (e) {
      e.preventDefault();
      var $addToCartForm = $(this).closest('form');
      Shopify.theme.jsAjaxCart.addToCart($addToCartForm);
      return false;
    });
    $(document).on('click', '[data-ajax-cart-delete]', function (e) {
      e.preventDefault();
      var lineID = $(this).parents('[data-line-item]').data('line-item');
      Shopify.theme.jsAjaxCart.removeFromCart(lineID);

      if (Shopify.theme.jsCart) {
        Shopify.theme.jsCart.removeFromCart(lineID);
      }

      return false;
    });
    $(document).on('click', '[data-ajax-cart-close]', function (e) {
      e.preventDefault();
      Shopify.theme.jsAjaxCart.hideDrawer();
      Shopify.theme.jsAjaxCart.hideMiniCart();
      return false;
    });
  },
  showMiniCartOnHover: function showMiniCartOnHover() {
    var $el = $('[data-ajax-cart-trigger]');
    $el.hover(function () {
      if (Shopify.theme_settings.header_layout == 'centered' && $('.header-sticky-wrapper').hasClass('is-sticky')) {
        $('.header-sticky-wrapper [data-ajax-cart-trigger]').addClass('show-mini-cart');
      } else {
        $el.addClass('show-mini-cart');
      }
    }, function () {
      $el.removeClass('show-mini-cart');
    });
  },
  hideMiniCart: function hideMiniCart() {
    if (this.cart_action != 'mini_cart') return false;
    var $el = $('[data-ajax-cart-close]').parents('[data-ajax-cart-trigger]');
    $el.removeClass('show-mini-cart');
  },
  toggleMiniCart: function toggleMiniCart() {
    var $el = $('.mobile-header [data-ajax-cart-trigger]'); // Removes url to the cart page so user is not redirected

    $el.attr('href', '#');
    $el.off('click').on('click', function (e) {
      // If user clicks inside the element, do nothing
      if (e.target.closest('[data-ajax-cart-mini_cart]')) {
        return;
      } // Loads content into ajaxCart container for mobile header


      Shopify.theme.jsAjaxCart.initializeAjaxCartOnMobile(); // If user clicks outside the element, toggle the mini cart

      $el.toggleClass('show-mini-cart'); // Calculate height of mini cart

      var announcementHeight = 0;
      var mobileHeaderHeight = parseInt($('.mobile-header').height());

      if (typeof Shopify.theme.jsAnnouncementBar !== 'undefined' && Shopify.theme.jsAnnouncementBar.enable_sticky) {
        announcementHeight = Shopify.theme.jsAnnouncementBar.getAnnouncementHeight();
      }

      $('.mobile-header .theme-ajax-cart').css({
        height: "calc(100vh - ".concat(mobileHeaderHeight + announcementHeight, "px)")
      });
    });
  },
  showDrawer: function showDrawer() {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.addClass('is-visible');
    $('.ajax-cart__overlay').addClass('is-visible');
  },
  hideDrawer: function hideDrawer() {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.removeClass('is-visible');
    $('.ajax-cart__overlay').removeClass('is-visible');
  },
  removeFromCart: function removeFromCart(lineID, callback) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function success(cart) {
        Shopify.theme.jsAjaxCart.updateView();
      },
      error: function error(XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
      }
    });
  },
  initializeAjaxCart: function initializeAjaxCart() {
    Shopify.theme.asyncView.load('/cart', // template name
    'ajax' // view name (suffix)
    ).done(function (_ref) {
      var html = _ref.html,
          options = _ref.options;
      $('[data-ajax-cart-content]').html(html.content);

      /**
       * CUSTOM: Adding initial alcohol check here
       */
      Shopify.theme.jsAjaxCart.checkForAlcohol();
      if (Shopify.theme_settings.show_multiple_currencies) {
        convertCurrencies();
      }
    }).fail(function () {// some error handling
    });
  },
  checkForAlcohol: function checkForAlcohol(){
    var cart = fetch('/cart.js').then(res => res.json()).then(res => res);
    var products_with_abv = fetch("https://www.mcevoyranch.com/apps/wine-club/api/products?abv=true").then( res => res.json() ).then( res => res )

    Promise.all([cart, products_with_abv]).then((values) => {
      var cart = values[0];
      var abvItems = values[1];
      var cartItemIds = cart && cart.items.map(i => i.product_id);
      var abvItemIds = abvItems && abvItems.map(i => i.legacy_resource_id);
      if(cartItemIds.filter(id => abvItemIds.includes(id.toString())).length === 0){
        document.querySelectorAll(".disabled_add_btn").forEach( el => el.classList.remove("disabled_add_btn"))
        document.querySelectorAll(".datepicker_container").forEach( el => el.style.display = "none")
        document.querySelectorAll(".datepicker_container_static").forEach( el => el.style.display = "none")
        //button--add-to-cart
      } else {
        document.querySelectorAll(".datepicker_container").forEach( el => el.style.display = "block")
        document.querySelectorAll(".datepicker_container_static").forEach( el => el.style.display = "block")
        document.querySelectorAll(".cart__checkout button.add_to_cart").forEach( el => el.setAttribute("contains_alcohol", "true"))
        document.querySelectorAll(".header__spacer .button--add-to-cart").forEach( el => el.setAttribute("contains_alcohol", "true"))
      }
    })
  },
  initializeAjaxCartOnMobile: function initializeAjaxCartOnMobile() {
    this.toggleMiniCart();
    Shopify.theme.asyncView.load('/cart', // template name
    'ajax' // view name (suffix)
    ).done(function (_ref2) {
      var html = _ref2.html,
          options = _ref2.options;
      $('.mobile-header [data-ajax-cart-content]').html(html.content);

      if (Shopify.theme_settings.show_multiple_currencies) {
        convertCurrencies();
      }
    }).fail(function () {// some error handling
    });
  },
  addToCart: function addToCart($addToCartForm) {
    var $addToCartBtn = $addToCartForm.find('.button--add-to-cart');

    // Prevent double adds
    if ($addToCartForm.data('adding')) {
      return false;
    }
    $addToCartForm.data('adding', true);

    // Disable button immediately
    $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
    $addToCartBtn.find('span').text('Adding...');

    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $addToCartForm.serialize(),
      success: function success(product) {
        $addToCartForm.data('adding', false);

        var $el = $('[data-ajax-cart-trigger]');
        $addToCartBtn.find('.checkmark').addClass('checkmark-active');

        function addedToCart() {
          if (!isScreenSizeLarge()) {
            $el = $('.mobile-header [data-ajax-cart-trigger]');
            Shopify.theme.scrollToTop($el);
          } else {
            $el = $('[data-ajax-cart-trigger]');
          }

          $el.addClass('show-mini-cart');
          $addToCartBtn.find('span').removeClass('fadeInDown');
        }

        window.setTimeout(function () {
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
          $addToCartBtn.find('.text, .icon').removeClass('zoomOut').addClass('fadeInDown');
          $addToCartBtn.find('span').text('Add to Cart');
          $addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);
        }, 1000);

        Shopify.theme.jsAjaxCart.showDrawer();
        Shopify.theme.jsAjaxCart.updateView();

        if (Shopify.theme.jsCart) {
          $.ajax({
            dataType: 'html',
            url: '/cart',
            success: function success(html) {
              var cartForm = $(html).find('.cart__form');
              $('.cart__form').replaceWith(cartForm);

              if (Shopify.theme_settings.show_multiple_currencies) {
                convertCurrencies();
              }
            }
          });
        }
      },
      error: function error(XMLHttpRequest) {
        $addToCartForm.data('adding', false);
        $addToCartBtn.removeAttr('disabled').removeClass('disabled');
        $addToCartBtn.find('span').text('Add to Cart');

        var response = eval('(' + XMLHttpRequest.responseText + ')');
        console.log(response);
        response = response.description;
        var cartWarning = "<p class=\"cart-warning__message animated bounceIn\">".concat(response.replace('All 1 ', 'All '), "</p>");
        $('.warning').remove();
        $addToCartForm.find('.cart-warning').html(cartWarning);
      }
    });

    return false;
  },
  updateView: function updateView() {
    Shopify.theme.asyncView.load('/cart', // template name
    'ajax' // view name (suffix)
    ).done(function (_ref3) {
      var html = _ref3.html,
          options = _ref3.options;

      if (options.item_count > 0) {
        /**
         * Custom: Check and enable checkout button if no alcohol
         */
        Shopify.theme.jsAjaxCart.checkForAlcohol();
        var itemList = $(html.content).find('.ajax-cart__list');
        var cartDetails = $(html.content).find('.ajax-cart__details-wrapper');
        $('.ajax-cart__list').replaceWith(itemList);

        $('.ajax-cart__details-wrapper').replaceWith(cartDetails);
        $('.ajax-cart__empty-cart-message').addClass('is-hidden');
        $('.ajax-cart__form').removeClass('is-hidden');
        $('[data-ajax-cart-trigger]').addClass('has-cart-count');
        $('[data-bind="itemCount"]').text(options.item_count);
      } else {
        $('.ajax-cart__empty-cart-message').removeClass('is-hidden');
        $('.ajax-cart__form').addClass('is-hidden');
        $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
        $('[data-bind="itemCount"]').text('0');
      }

      if (Shopify.theme_settings.show_multiple_currencies) {
        convertCurrencies();
      }
    }).fail(function () {// some error handling
    });
  },
  unload: function unload($section) {
    // Clear event listeners in theme editor
    $('.ajax-submit').off();
    $('[data-ajax-cart-delete]').off();
  }
};

// IMPORTANT: Discount Ninja integration for automatic free gifts (e.g., Champagne Vinegar on 375ml Olive Oil)
// This listener refreshes the Flex Ajax cart drawer/main cart when DN adds a gift item.
// It listens for DN's 'drawercart:refreshed' event and calls updateView() to show the gift instantly without reloading the page.
// DO NOT REMOVE unless replacing with a different refresh method.
// If changing DN settings (Refresh Behavior), ensure this matches the Publish event call.

document.addEventListener("limoniapps:discountninja:drawercart:refreshed", function (event) {
  if (typeof Shopify !== 'undefined' && Shopify.theme && Shopify.theme.jsAjaxCart && Shopify.theme.jsAjaxCart.updateView) {
    Shopify.theme.jsAjaxCart.updateView();
  }
});